import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';
declare var bootstrap: any;

@Component({
  selector: 'app-awards-champions',
  templateUrl: './champions.component.html',
  styleUrls: ['./champions.component.scss']
})
export class ChampionsComponent implements OnInit {

  champions: any;
  @Input() month = null;
  u = Utils;

  popup:any;

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getChampions();

    Utils.setupPopover();

  }

  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...
    //console.log(changes);
    this.getChampions();
   }

  getChampions(){

    this.okService.get("awards/workers",{month:this.month})
    .subscribe((data) => {

      this.champions = data.body;

      //console.log('getChamps', data);

    });

  }

  showPopup(champion:any){
    this.popup = champion;

    var myModal = new bootstrap.Modal(document.getElementById('summaryModal'));
    myModal.show();


  }

}
